import { Flex, List } from "@chakra-ui/react";
import Stay22HotelBooking from "@components/Stay22/Stay22HotelBooking";
import { MS_END } from "@models/timezone";
import CheckoutSuccessButtons from "../CheckoutSuccessButtons/CheckoutSuccessButtons";
import {
  CalendarCard,
  ContactUsCard,
  ShareEventCard,
} from "../CheckoutSuccessCTA/CheckoutSuccessCTACards";
import CheckoutSuccessContainer from "../CheckoutSuccessContainer/CheckoutSuccessContainer";
import CheckoutSuccessEventInfoCard from "../CheckoutSuccessEventInfo/CheckoutSuccessEventInfoCard/CheckoutSuccessEventInfoCard";
import {
  EventHost,
  EventLocation,
  EventTime,
} from "../CheckoutSuccessEventInfo/CheckoutSuccessEventInfoItems/CheckoutSuccessEventInfoItems";
import CheckoutSuccessHeadings from "../CheckoutSuccessHeadings/CheckoutSuccessHeadings";
import { CheckoutSuccessContentProps } from "../types";

const HOST = process.env.NEXT_PUBLIC_HOST || "https://app.moongate.id";

const CheckoutSuccessTicket = ({
  event,
  tier,
  info,
  itemsCount,
  language,
}: CheckoutSuccessContentProps) => (
  <>
    <CheckoutSuccessContainer>
      <CheckoutSuccessHeadings heading="Purchase Confirmed" />

      <CheckoutSuccessEventInfoCard
        imgSrc={tier?.imageUrl || info.hero || info.banner}
        cardTitle={info.name}
        itemsCount={itemsCount}
      >
        <List
          marginTop={4}
          spacing={4}
          style={{ maxWidth: "20rem", wordWrap: "break-word" }}
        >
          {event.start > 0 && event.end !== MS_END && (
            <EventTime event={event} info={info} />
          )}
          {info.location && <EventLocation info={info} />}
          {info.organizer && info.organizer.name && (
            <EventHost eventType={event.type} info={info} language={language} />
          )}
        </List>
      </CheckoutSuccessEventInfoCard>
      <CheckoutSuccessButtons
        redirectToAppText="Check my ticket"
        redirectToEventText="Back to Event"
      />
      <Flex
        width="max-content"
        direction={{ base: "column", lg: "row" }}
        justifyContent="center"
        alignItems="stretch"
        marginTop={8}
        gap={6}
      >
        <ShareEventCard
          eventType={event.type}
          language={language}
          url={event.toURL(HOST)}
        />
        <CalendarCard
          info={info}
          language={language}
          start={event?.start}
          end={event?.end}
          timezone={event?.timezone}
        />
        <ContactUsCard language={language} />
      </Flex>
      <Stay22HotelBooking info={info} event={event} />
    </CheckoutSuccessContainer>
  </>
);

export default CheckoutSuccessTicket;
